export default __webpack_public_path__ + "static/media/laptop.88e3b53b.png";